<template>
  <section class="hero is-link is-fullheight-with-navbar">
    <div class="hero-body">
      <div class="container has-text-centered">
        <p class="title">RE InVent App Store</p>
        <p class="description">Android Apps made with Java</p>
        <br />
        <i class="fa fa-code fa-3x" aria-hidden="true"></i>
        <div class="container">
          <div class="notification is-primary"></div>
        </div>
        <div
          class="
            columns
            is-variable
            is-1-mobile
            is-0-tablet
            is-3-desktop
            is-8-widescreen
            is-2-fullhd
            is-centered
          "
        >
          <div class="column is-2">
            <figure class="image is-3by1">
              <img src="../assets/badge_english_dark.png" />
            </figure> 
          </div>
          <div class="column is-2">
            <figure class="image is-3by1">
              <img src="../assets/en_badge_web_generic.png" />
            </figure>
          </div>
          <div class="column is-2">
            <figure class="image is-3by1">
              <img src="../assets/amazon-appstore-badge-english-black.png" />
            </figure>
          </div>
        </div>
      </div>
    </div>
  </section>
  <router-view></router-view>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
